function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { IconButton, Tooltip } from 'seagull';
import { AnchorIcon, AnchorIconGrayscale } from 'seagull/icons';
import { Intent } from "../../infra/access-control";
export default function EnterAccountantAccessButton(props) {
  const {
    variant = 'default',
    testid,
    onClick
  } = props;
  const buttonProps = {
    noPadding: true,
    size: 'small',
    skin: 'transparent',
    'data-testid': testid,
    onClick
  };
  return variant === 'default' ? /*#__PURE__*/React.createElement(Tooltip, {
    placement: "top",
    title: "Go to client portal"
  }, /*#__PURE__*/React.createElement(IconButton, _extends({}, buttonProps, {
    intent: Intent.EnterAccountantAccess
  }), /*#__PURE__*/React.createElement(AnchorIcon, {
    width: 24
  }))) : /*#__PURE__*/React.createElement(Tooltip, {
    placement: "top",
    title: "Pending Accountant Access approval"
  }, /*#__PURE__*/React.createElement(IconButton, _extends({}, buttonProps, {
    cursorDefault: true
  }), /*#__PURE__*/React.createElement(AnchorIconGrayscale, null)));
}